//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Tooltip,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import {Spacer} from 'components/Spacer';
import { Menu } from 'pages/Menu';
import ReviewStatusSelect from './components/ReviewStatusSelect/ReviewStatusSelect';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function HeaderTaskView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const navigate = useNavigate();

  const [ file_name , setFileName ] = useState( '' );

  //#endregion

  //#region [STYLES]

  const _styles = {
    button_back: {
      height: '40px',
      margin: '0 6px',
    },
  }

  const tooltip_font_large = {
    slotProps: {
      tooltip: {
        sx: {
          fontSize: '14px', // Set your custom size here
        },
      },
    }
  }

  const BUTTON_BACK = {      
    sx       : _styles.button_back,
    variant  : 'contained',
    color    : 'error',
    onClick  : () => { navigate( -1 ) },
    children : <ArrowBack fontSize='large'/>,
    name     : 'da_close_task_view_btn',
  };

  //#endregion
  
  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleFile(data) {
      //-----------------------------------------------------------------
      if( data?.name ) setFileName( data?.name );
    }

    on( 'FILE', handleFile );

    return () => {
      removeListener( 'FILE' , handleFile );
    };
  }, [] )

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Menu>
        <Styled styles={[ {display: 'flex'}, {alignItems:'center'}]}>
          <Styled styles={[{width:'fit-content', height: 'fit-content'}, { fontSize: '20px' }, { padding: '4px 8px 4px 8px' } ]}>
            {file_name}
          </Styled>
          <ReviewStatusSelect />
          <Spacer push_right />
          <Tooltip title="Go Back" { ...tooltip_font_large } >
            <Button { ...BUTTON_BACK } />
          </Tooltip>
        </Styled>
      </Menu>
    )
  }

  //#endregion

  return display();
}
